import axios from 'axios';
import { iframeDataBridge } from '../iframe/iframeDataBridge.js';
import { getApiUrl, getAuthHeaders } from '@/utils/auth/authService.js';

async function getAppointments(params = {}, successCallback = null, errorCallback = null) {
	let data = null;

	if (iframeDataBridge.isOnline()) {
		const url = getApiUrl(`/Sales/Appointments`);
		const headers = await getAuthHeaders({}, 'tokenSales');
		const response = await axios.get(url, { params: params, headers: headers });
		data = response?.data || null;
	} else {
		data = iframeDataBridge.getStorage().get('SFA_APPOINTMENTS', successCallback, errorCallback);
	}

	if (data && successCallback) {
		successCallback(data);
	}

	if (!data && errorCallback) {
		errorCallback(new Error('No data received'));
	}

	return data;
}

export const appointmentService = {
	getAppointments: getAppointments,
};
